import { faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import EditUser from "../EditUser";
import UserDelete from "./UserDelete";
import CustomTooltip from "../../common/CustomTooltip";
import ActivityLogList from "../../common/ActivityLogList";

const UserActionButton = ({ id, userModal }) => {
  const [showDelete, setShowDelete] = useState(false);
  const [showUser, setShowUser] = useState(false);

  const toggleUserModal = () => {
    showUser && userModal();

    setShowUser(!showUser);
  };

  const toggleDeleteModal = () => {
    setShowDelete(!showDelete);
  };
  return (
    <>
      <span>
        {/* <FontAwesomeIcon
          onClick={toggleShowModal}
          icon={faEye}
          size="1x"
          data-toggle="modal"
          data-target="#clientDetail"
        /> */}
        {/* <span></span>&nbsp;&nbsp;/&nbsp;&nbsp; */}
        <ActivityLogList id={id} />
        <span></span>&nbsp;&nbsp;/&nbsp;&nbsp;
        <CustomTooltip message={"Edit"}>
          <span>
            <FontAwesomeIcon
              icon={faEdit}
              size="1x"
              onClick={toggleUserModal}
            />
          </span>
        </CustomTooltip>
        <span></span>&nbsp;&nbsp;/&nbsp;&nbsp;
        <CustomTooltip message={"Delete"}>
          <span>
            <FontAwesomeIcon
              onClick={toggleDeleteModal}
              icon={faTrash}
              size="1x"
              data-toggle="modal"
              data-target="#deleteClient"
            />
          </span>
        </CustomTooltip>
      </span>

      {showDelete && (
        <UserDelete
          userId={id}
          toggleDeleteModal={toggleDeleteModal}
          handleDelete={userModal}
          showDelete={showDelete}
        />
      )}

      {showUser && (
        <EditUser
          userId={id}
          showUser={showUser}
          toggleUserModal={toggleUserModal}
        />
      )}

      {/* {showView && (
        <UserDetailPopup
          showView={showView}
          userId={id}
          toggleShowModal={toggleShowModal}
        />
      )} */}
    </>
  );
};

export default UserActionButton;
